var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvalid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5909 12L18.0441 7.54687C18.4842 7.10755 18.4848 6.39463 18.0455 5.95453C17.6061 5.51443 16.8932 5.5138 16.4531 5.95312L12 10.4062L7.54687 5.95312C7.10677 5.51302 6.39323 5.51302 5.95312 5.95312C5.51302 6.39323 5.51302 7.10677 5.95312 7.54687L10.4062 12L5.95312 16.4531C5.51302 16.8932 5.51302 17.6068 5.95312 18.0469C6.39323 18.487 7.10677 18.487 7.54687 18.0469L12 13.5937L16.4531 18.0469C16.8932 18.487 17.6068 18.487 18.0469 18.0469C18.487 17.6068 18.487 16.8932 18.0469 16.4531L13.5909 12Z",
    fill: "#E80048"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalid);
export default __webpack_public_path__ + "static/media/invalid.26508baa6bc9954e6de5489f98a48a76.svg";
export { ForwardRef as ReactComponent };